import { DatePipe } from '@angular/common';
import {
  Component,
  OnInit,
  Inject,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-issue-seller-address-gstreport',
  templateUrl: './issue-seller-address-gstreport.component.html',
  styleUrls: ['./issue-seller-address-gstreport.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IssueSellerAddressGSTReportComponent implements OnInit {

  GSTfullreportFormBeans: any[] = [];
  reportType: string = 'GSTFullReport';
  GSTAdvtAmt = 0;
  GSTDiscount = 0;
  GSTNetAdvtAmt = 0;
  CGSTAmount = 0;
  SGSTAmount = 0;
  IGSTAmount = 0;
  AllGSTAmount = 0;
  beforegstamt = 0;

  startDate: any;
  endDate: any;
  offRepName: string = '';
  issueDates1: any;
  issueDates: any;
  currentDate: string;

  constructor(
      private dialogRef: MatDialogRef<IssueSellerAddressGSTReportComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private service: DigisubservicesService,
      private cdr: ChangeDetectorRef,
      private fb: FormBuilder,
      private datePipe: DatePipe
    ) {}
  
  ngOnInit(): void {
    debugger
    this.loadGSTFullReport();
  }

  loadGSTFullReport(): void {
    const repname = ''; // set repname as needed
    // const req: any = {
    //   "rep_name": repname,
    //   "startDate": this.startDate,
    //   "endDate": this.endDate,
    //   "off_rep_name": this.offRepName,
    //   "issue_seller_name": this.data['name'],
    //   "issue_date": this.issueDates
    // };

    const req1: any = {
      "startDate": this.data['startDate'],
      "endDate": this.data['endDate'],
      // "issue_seller_name": this.data['name']
    };
    this.startDate=this.data['startDate']
    this.endDate=this.data['endDate']
    const today = new Date();
    this.currentDate = today.toISOString().split('T')[0]; 

    this.service.IssueGSTFullReport(req1).subscribe((data: any) => {
      console.log("GST", data);
      this.GSTfullreportFormBeans = data || [];

      // Reset totals
      this.GSTAdvtAmt = 0;
      this.GSTDiscount = 0;
      this.GSTNetAdvtAmt = 0;
      this.CGSTAmount = 0;
      this.SGSTAmount = 0;
      this.IGSTAmount = 0;
      this.AllGSTAmount = 0;
      this.beforegstamt = 0;

      for (let item of this.GSTfullreportFormBeans) {
        this.GSTAdvtAmt += parseInt(item.adv_amt) || 0;
        this.GSTDiscount += parseInt(item.advt_discount) || 0;
        this.GSTNetAdvtAmt += parseInt(item.net_amt) || 0;
        this.CGSTAmount += parseInt(item.cgst) || 0;
        this.SGSTAmount += parseInt(item.sgst) || 0;
        this.IGSTAmount += parseInt(item.igst) || 0;
        this.AllGSTAmount += parseInt(item.gst_amount) || 0;
        this.beforegstamt += parseInt(item.before_gst_amt) || 0;
      }

      this.cdr.markForCheck(); // Trigger UI update
    });

    
  }
    exportExcel(fileName) {
      /* table id is passed over here */
      let element = document.getElementById('print-section');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
  
      /* save to file */
      XLSX.writeFile(wb, fileName + '.xlsx');
    }
  
}

